"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthType = void 0;
var OAuthType;
(function (OAuthType) {
    OAuthType["AUTHORIZATION_CODE"] = "authorization_code";
    OAuthType["CLIENT_CREDENTIALS"] = "client_credentials";
})(OAuthType = exports.OAuthType || (exports.OAuthType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJmYWNlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbnRlcmZhY2VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQStHQSxJQUFZLFNBR1g7QUFIRCxXQUFZLFNBQVM7SUFDbkIsc0RBQXlDLENBQUE7SUFDekMsc0RBQXlDLENBQUE7QUFDM0MsQ0FBQyxFQUhXLFNBQVMsR0FBVCxpQkFBUyxLQUFULGlCQUFTLFFBR3BCIn0=